(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Dentity", [], factory);
	else if(typeof exports === 'object')
		exports["Dentity"] = factory();
	else
		root["Dentity"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return 